import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=3fe8673a&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=3fe8673a&lang=scss&scoped=true"
import style1 from "./Recovery.vue?vue&type=style&index=1&id=3fe8673a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8673a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe8673a')) {
      api.createRecord('3fe8673a', component.options)
    } else {
      api.reload('3fe8673a', component.options)
    }
    module.hot.accept("./Recovery.vue?vue&type=template&id=3fe8673a&scoped=true", function () {
      api.rerender('3fe8673a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Debugger/Recovery.vue"
export default component.exports